/**
 * Component that emits named in-studio `screen_*` events on room entry
 * (ENG-4324, plan SCR-1).
 *
 * Childless and render-null by design: it exists only to host useScreenTracker at
 * the stable app root (see the hook for the once-per-room-entry rationale). It is
 * a SIBLING of PageviewTracker rather than a wrapper or a child of one, so the
 * named-screen concern neither touches the generic $pageview URL contract nor
 * inherits another tracker's mount condition — the screens must be emitted in
 * every environment, not only where the $pageview owner or the third-party tag
 * loaders happen to mount.
 */

import { useScreenTracker } from '#~/analytics/screens/use-screen-tracker.js';

export const ScreenTracker = (): null => {
  useScreenTracker();

  return null;
};
